// extracted by mini-css-extract-plugin
module.exports = {"split":"split"};